// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"PdfModal_backdrop__22vTu","modal":"PdfModal_modal__1THdk","header":"PdfModal_header__C4Kwf","content":"PdfModal_content__h1knt","actions":"PdfModal_actions__2YSQo"};